import React from 'react';
import { m } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream-dark py-10 sm:py-14" data-id="element-64" data-mp="20meizq13l45g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-65" data-mp="24ngk6cekrqa2">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-navy/10 bg-white p-8 sm:p-10" data-id="element-66" data-mp="24l3rb47a3vi8">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-orange/10" data-id="element-67" data-mp="2jat827ruu83m">
            <ShieldCheckIcon size={32} className="text-orange-hover" data-id="element-68" data-mp="2ocik9qqtcrta" />
          </div>
          <h2 className="mt-5 font-heading text-2xl font-extrabold uppercase leading-tight text-navy sm:text-3xl" data-id="element-69" data-mp="2sbrfz15eyzrh">
            Garantía de 7 Días
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-ink sm:text-base" data-id="element-70" data-mp="xyruwsi9ldct">
            Si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo
            recibido no corresponde con la oferta mostrada en esta página, escríbenos a{' '}
            <a href="mailto:manualeslistos@gmail.com" className="font-medium text-orange-hover underline" data-id="element-71" data-mp="3ivmymh27ezv7">
              manualeslistos@gmail.com
            </a>{' '}
            y lo resolveremos.
          </p>
        </m.div>
      </div>
    </section>;
}